import { challengeOptions, CHALLENGE_STATUS, CHALLENGE_CATEGORY_STATUS } from "./constants";

export const initialState = {
  challenges: {
    categories: {
      operations: {
        id: 'operations',
        name: 'Operations',
        icon: '⚙️',
        instanceIds: []
      },
      sales: {
        id: 'sales',
        name: 'Sales',
        icon: '💰',
        instanceIds: []
      },
      marketing: {
        id: 'marketing',
        name: 'Marketing',
        icon: '📢',
        instanceIds: []
      },
      product: {
        id: 'product',
        name: 'Product',
        icon: '📦',
        instanceIds: []
      },
      uncategorized: {
        id: 'uncategorized',
        name: 'Select Category',
        icon: '📋',
        instanceIds: []
      }
    },
    instances: {},
    active_category_id: null,
  },
  challenge_options: challengeOptions,
  // Metadata for UI state
  active_category_id: null,
};
